import { render, staticRenderFns } from "./SidebarVerifikasiProbonoCLE.vue?vue&type=template&id=229b0e2e&"
import script from "./SidebarVerifikasiProbonoCLE.vue?vue&type=script&lang=js&"
export * from "./SidebarVerifikasiProbonoCLE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports